export const APPLICATION_FILLOUT_DATA_REQUEST =
  'APPLICATION_FILLOUT_DATA_REQUEST';
export const APPLICATION_FILLOUT_DATA_SUCCESS =
  'APPLICATION_FILLOUT_DATA_SUCCESS';
export const APPLICATION_FILLOUT_DATA_FAIL = 'APPLICATION_FILLOUT_DATA_FAIL';
